import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class MolassesApi {
  create(data) {
    return api.post(API_URLS.URL.molasses, data);
  }
  getList(data) {
    return api.post(API_URLS.URL.getMolassesList, data);
  }
  getMolasses(id) {
    return api.get(API_URLS.URL.getMolasses?.replace(":id", id));
  }
  updateMolasses(data) {
    return api.put(API_URLS.URL.updateMolasses?.replace(":id", data?.id), data);
  }
  getFermentationOptions() {
    return api.get(API_URLS.URL.getFermentationOptions);
  }
  sendToFermentation(data) {
    return api.post(API_URLS.URL.sendToFermentationMolasses, data);
  }
  removeMolassesFermentation(id) {
    return api.delete(API_URLS.URL.removeMolassesFermentation?.replace(":id", id));
  }
}
